module.exports = __webpack_public_path__ + "media/images/contents/questionnaires/template_pattern_1-741c385a52c79410338d83d28c7b60ea.png";